/**
 * 파일 업로드 제한 상수
 */

/** 배경 이미지/숏폼 배경 최대 등록 수 */
export const MAX_BACKGROUND_ITEMS = 20;

/** 이미지 최대 크기 (10MB) */
export const MAX_IMAGE_SIZE = 10 * 1024 * 1024;

/** 영상 최대 크기 (50MB) */
export const MAX_VIDEO_SIZE = 50 * 1024 * 1024;

/** 허용 이미지 형식 */
export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

/** 허용 영상 형식 (숏폼·롱폼 공통) */
export const ALLOWED_VIDEO_TYPES = ['video/mp4', 'video/x-m4v', 'video/webm', 'video/quicktime'];
